selectSeriesDetailData